import ProjectIcon from '@mui/icons-material/AttachMoney';
import ProjectList from './list';
import ProjectEdit from './single/indexEdit';
import ProjectShow from './single'
import ProjectCreate from './single/indexCreate'

export default {
    create: ProjectCreate,
    list: ProjectList,
    edit: ProjectEdit,
    icon: ProjectIcon,
    show: ProjectShow
};

